import { render, staticRenderFns } from "./perseo_despachos_hoja_ruta.vue?vue&type=template&id=15561388&scoped=true"
import script from "./perseo_despachos_hoja_ruta.vue?vue&type=script&lang=js"
export * from "./perseo_despachos_hoja_ruta.vue?vue&type=script&lang=js"
import style0 from "./perseo_despachos_hoja_ruta.vue?vue&type=style&index=0&id=15561388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15561388",
  null
  
)

export default component.exports